import { Routes } from '@angular/router';
import { PageKey } from '../../../shared/services/page/models/page.key';
import { usersRoute } from './users/users.config';
import { departmentsRoute } from './departments/departments.config';
import { canActivate } from '../../../shared/guard/guard';
import { HeaderEnum, PermissionEnum } from '../../../../environments/shared-environment/permission';

export const usersManageRoute: Routes = [{
  path: 'users',
  canActivateChild: [() => canActivate(HeaderEnum.USERS, PermissionEnum.CREATE)],
  loadComponent: () => import('./users-manage.component').then(m => m.UsersComponent),
  children: [
    {
      path: '',
      loadComponent: () => import('./users/list/list.component').then(m => m.ListComponent),
      data: {
        title: 'Listar Usuários',
        key: PageKey.USERS
      },
    },
    ...usersRoute,
    ...departmentsRoute
  ]
}];
